import React from 'react';
import { motion } from 'framer-motion';
import { Ship, CheckCircle } from 'lucide-react';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import SEO from '../components/SEO';

const SeaFreight = () => {
  const services = [
    'Full Container Load (FCL)',
    'Less than Container Load (LCL)',
    'Port-to-port services',
    'Door-to-door solutions',
    'Customs clearance',
    'Marine insurance',
    'Container tracking',
    'Documentation handling',
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO title="Global Sea Freight Solutions | Aero Time Critical" description="Full-container load, less-than-container load and groupage sea freight, port-to-port and door-to-door with import/export and customs coordination." path="/sea-freight" />
      <PageHero
        badge="OCEAN FREIGHT"
        BadgeIcon={Ship}
        title="Sea Freight"
        titleAccent="Solutions"
        description="Cost-effective ocean freight for larger shipments with comprehensive port-to-door services and global carrier partnerships."
        image="https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/oeutyc9r_Sea%20Freight.webp"
      />

      <section className="bg-[#F7F9FB] py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <span className="text-[#0089D0] font-semibold tracking-wide uppercase text-sm">Global Ocean Network</span>
              <h2 className="text-3xl md:text-4xl font-bold mt-3 mb-8 text-[#003057]">
                Comprehensive Sea Freight
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {services.map((service, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.05 }}
                    className="flex items-center gap-3"
                  >
                    <CheckCircle className="text-[#0089D0] flex-shrink-0" size={22} />
                    <span className="text-[#003057] font-medium">{service}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/oeutyc9r_Sea%20Freight.webp"
                alt="Container ship carrying sea freight cargo"
                className="w-full h-[450px] object-cover rounded-lg shadow-xl"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
      </section>

      <CTASection
        title="Plan Your Ocean Shipment"
        description="Competitive rates for FCL and LCL shipments worldwide"
        buttonText="Request Sea Freight Quote"
      />
    </div>
  );
};

export default SeaFreight;
